import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { Component, ViewChild } from '@angular/core';
import { UserService } from 'src/app/core/service/user.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { MessageSubject, MessengerService } from 'src/app/core/service/messenger.service';

@Component({
  standalone: false,
  selector: 'app-select-role',
  templateUrl: './select-role.component.html',
  styleUrls: ['./select-role.component.scss'],
  providers: []
})
export class SelectRoleComponent
{
  @ViewChild('selectButton') public selectButton: any;

  public dialogOpened = false;
  public activeRoles = [];
  public selectedRole: string;
  public roleSelectionPromise: Promise<string>;

  private userName: string;
  private currentRole: string;
  private resolve: any;

  constructor(
    private userService: UserService,
    private messengerService: MessengerService,
    private authenticationService: AuthenticationService,
    private messageHandlerService: MessageHandlerService) { }

  public execute(userName: string, currentRole: string, activeRoles: any): Promise<string>
  {
    this.userName = userName;
    this.currentRole = currentRole;
    this.activeRoles = activeRoles;
    this.selectedRole = currentRole;
    this.dialogOpened = true;

    setTimeout(() =>
    {
      if (this.selectButton)
      {
        this.selectButton.nativeElement.focus();
      }
    });

    this.roleSelectionPromise = new Promise(resolve =>
    {
      this.resolve = resolve;
    });
    return this.roleSelectionPromise;
  }

  public close(): void
  {
    // If used from the header and hit close, it will not set automatically but just close the modal.
    if (this.authenticationService.isAuthenticated)
    {
      this.dialogOpened = false;
      this.resolve(null);
    }
    else
    {
      this.select();
    }
  }

  public select(): void
  {
    this.dialogOpened = false;
    // If selected role is different from authentication, update user role and continue process
    if (this.currentRole !== this.selectedRole)
    {
      this.userService.updateUserActiveRole(this.userName, this.selectedRole).subscribe({
        next: () =>
        {
          this.resolve(this.selectedRole);
          this.messengerService.sendMessage(new MessageSubject('role-changed', { selectedRole: this.selectedRole }));
        },
        error: (errorResponse) =>
        {
          this.messageHandlerService.displayError(errorResponse);
          this.resolve(this.selectedRole);
        }
      });
    }
    else
    {
      this.resolve(this.selectedRole);
    }
  }
}
